module.exports = __webpack_public_path__ + "img/ATRC Platform - Privacy Policy -3.df375423.png";